// Import React library and components from Material-UI and custom components
import React from 'react';
import TemporaryDrawer from "./drawer";
import { Link } from "react-router-dom";
import "./Header.css";
import Container from '@mui/material/Container';

/**
 * Header component renders the navigation header.
 * @returns {JSX.Element} - Header component.
 */
const Header = () => {
  return (
    // Container with sticky position and styling for the header
    <Container maxWidth="lg" sx={{
      position: "sticky",
      top: 0,
      zIndex: 100,
      backgroundColor: "var(--theme-bg-color-primary)"
    }}>
      <div className="navbar">
        {/* Link to the homepage */}
        <Link to="/">
          <p className="link">InsightCoin</p>
        </Link>
        {/* Navigation links */}
        <div className="links">
          <Link to="/">
            <p className="link">Home</p>
          </Link>
          <Link to="/coins">
            <p className="link">Coins</p>
          </Link>
          <Link to="/compare">
            <p className="link">Compare</p>
          </Link>
          <Link to="/starred">
            <p className="link">Starred</p>
          </Link>
        </div>
        {/* Mobile drawer for responsive navigation */}
        <div className="mobile-drawer">
          <TemporaryDrawer />
        </div>
      </div>
    </Container>
  );
}

// Export the Header component as the default export of the module
export default Header;
